import { render, staticRenderFns } from "./HealthListItem.vue?vue&type=template&id=fac149e6&"
import script from "./HealthListItem.vue?vue&type=script&lang=ts&"
export * from "./HealthListItem.vue?vue&type=script&lang=ts&"
import style0 from "./HealthListItem.vue?vue&type=style&index=0&id=fac149e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports